import { defineComponent, onMounted, PropType, ref, inject } from "vue";
import { Image } from "@/interfaces/Image";
import {
  animateTransitionImages,
  showUIAndRestOfPage,
} from "@/shared-animations/hero";
import gsap from "gsap";
export default defineComponent({
  props: {
    line1: { type: String, required: false },
    line1MaskHeight: { type: Number, default: 100 },
    line1Indent: { type: Number, default: 0 },
    line2: { type: String, required: false },
    line2MaskHeight: { type: Number, default: 100 },
    line2Indent: { type: Number, default: 0 },
    line3: { type: String, required: false },
    line3MaskHeight: { type: Number, default: 100 },
    line3Indent: { type: Number, default: 0 },
    line4: { type: String, required: false },
    line4MaskHeight: { type: Number, default: 100 },
    line4Indent: { type: Number, default: 0 },
    loadedInStorybook: { type: Boolean, default: false },
    images: { type: Array as PropType<Image[]>, required: false },
  },
  setup(props) {
    const heroRef = ref<HTMLElement | null>(null);
    const emitter = inject("emitter");
    const showImages = window.innerWidth >= 768;
    const templateOrder = ref(1);

    onMounted(() => {
      // return true; // temp disable animation

      templateOrder.value =
        props.images && props.images.length > 0
          ? Math.floor(Math.random() * props.images!.length) + 1
          : 1;

      const heroTL = gsap.timeline({
        delay: window.innerWidth > 768 ? 0.75 : 0,
        onComplete: () => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore:next-line
          emitter.emit("page-transitions-finished");
        },
      });

      const imageContainers = heroRef.value!.querySelectorAll(
        ".transition_image__container"
      );

      const heroHasImages = imageContainers.length > 0;

      animateTransitionImages(heroTL, imageContainers);

      heroTL
        .add(
          function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore:next-line
            emitter.emit("pagewrapper-background-animation--stop", 3);
          },
          heroHasImages ? "-=1.5" : "+=0"
        )
        .addLabel("going-down-finished", heroHasImages ? "+=0.5" : "+=1");

      // ANIMATE LETTERS IN
      heroTL.from(
        ".hero__title .nmm_title__line",
        {
          yPercent: 100,
          duration: 1.6,
          ease: "power4.out",

          stagger: { amount: 0.25 },
        },
        "going-down-finished+=0.2"
      );

      // ANIMATE UI IN
      heroTL.addLabel("showUI", "going-down-finished");

      showUIAndRestOfPage(heroTL);
    });

    return { heroRef, showImages, templateOrder };
  },
});
